export const localeToBaseLanguageMap = Object.freeze({
  'es-mx': 'es',
  'fr-ca': 'fr'
});

export const localeToReadableLanguageMap = Object.freeze({
  en: 'English (en)',
  'es-mx': 'Espanol (es-mx)',
  'fr-ca': 'French Canadian (fr-ca)',
  'pt-br': 'Portuguese (pt-br)'
});

export function useLocaleHelpers() {
  function getBaseLanguageCodeFromLocale(locale) {
    const key = locale.toLowerCase();
    return localeToBaseLanguageMap[key] ?? key;
  }

  function getReadableLanguageFromLocale(locale) {
    const key = locale.toLowerCase();
    return localeToReadableLanguageMap[key] ?? key;
  }

  function setLocaleToLocalStorage(userId, locale = 'en') {
    localStorage.setItem(`user_${userId}_locale`, locale);
  }

  function getLocaleFromLocalStorage(userId) {
    return localStorage.getItem(`user_${userId}_locale`) ?? 'en';
  }

  return {
    getBaseLanguageCodeFromLocale,
    setLocaleToLocalStorage,
    getLocaleFromLocalStorage,
    getReadableLanguageFromLocale
  };
}
